import React, {
  FC, useMemo, useState, useEffect, useCallback, useRef,
} from 'react';
import _, { identity } from 'lodash';
import classnames from 'classnames';
import { Box, useSelectionContainer, boxesIntersect } from 'react-drag-to-select';
import Checkbox from 'app/components/general/Checkbox';

import Table from 'app/components/general/Table';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';

import {
  getTeamMemberSummary, getTeamMemberRowData, getTeamMemberRowState, getTeamMemberRowDataNew,
} from 'app/ducks/teamMembers/selectors';
import { ITeamMember } from 'app/ducks/teamMembers/types';

import Isvg from 'react-inlinesvg';
import ManagerIcon from 'app/images/icons/crown.svg';
import PersonIcon from 'app/images/icons/person.svg';

export interface ITeamMemberRow {
  [id: string]: {
    selected?: boolean;
    amount?: string;
    id?: string;
    floatAmount?: number;
  };
}

interface IProps {
  actions: any;
  headerTitle?: string;
  appReady?: boolean;
  isLoading?: boolean;
  manual?: boolean;
  saveFilters?: boolean;
  initialFilterConfig?: any;
  persistentFilterConfig?: any;
  pagination?: any;
  filterable?: boolean;
  rows: { [key: string]: ITeamMemberRow };
  teamMembersById: ITeamMember[];
  teamMemberIds: string[];
  teamId?: string;
  updateSelectedRows?: Function;
  toggleTeamMemberCreateModal?: Function;
  selectedAllRows?: boolean;
  selectRow?: Function;
  selectAllRows?: Function;
  removeRow?: Function;
  removeAllRows?: Function;
  selectedRows?: any;
  selectedRowIds?: string[];
  selectedRowsById?: any;
  handleAmountChange: Function;
  handleQuantityChange: Function;
  splitType: string;
  tableState: any;
}

const MouseSelection = React.memo(({ onSelectionChange, onSelectionEnd }) => {
  const { DragSelection } = useSelectionContainer({
    // eventsElement: document.getElementById('team-members-selectable'),
    onSelectionChange,
    selectionProps: {
      style: {
        border: '1px solid #387abf',
        backgroundColor: '#d2e8ff',
        opacity: 0.5,
        zIndex: 999,
        position: 'absolute',
      },
    },
  });

  return <DragSelection />;
});

const renderCheckboxHeader = ({
  column: { selectAllRows },
  state: { selectedAllRows },
}) => (
  <div className="row w-100">
    <div className="col col-6 col-lg-4">
      <div className="d-flex align-items-center">
        <Checkbox
          onClick={(e) => {
            e.stopPropagation();
            selectAllRows();
          }}
          checked={selectedAllRows}
        />
        {' '}
        Name
      </div>
    </div>
    <div className="col col-6 col-lg-4">
      Team
    </div>
  </div>
);

const renderTeamMemberRow = ({
  value: initialValue,
  row: { index, original: { id }, state },
  rows,
  column: {
    handleChange, handleQuantityChange, selectRow, setSelectedIndexes, selectedIndexes,
  },
}): React.ReactNode => {
  const onChange = (values) => {
    handleChange(id, values);
  };

  const onQuantityChange = (e) => {
    e.preventDefault();
    if (e.target?.value <= 0) {
      e.target.value = 1;
    }
    handleQuantityChange(id, e.target?.value);
  };
  // , { 'margin-top-10': initialValue?.selected }
  // console.log(state);
  // // console.log(id);
  // if (id === 'acb1f107-dfa9-405b-b4cb-eb9070f7c1ef') {
  const splitType = initialValue?.splitType;
  // console.log(splitType);
  // }
  return (
    <div key={`row-${id}`} className="w-100">
      <div className="row">
        <div className="col col-6 col-lg-4">
          <div className="d-flex align-items-center h-100">
            <Checkbox
              key={`${id}-checkbox`}
              onMouseDown={(e) => { e.stopPropagation(); }}
              onMouseMove={(e) => { e.stopPropagation(); }}
              onClick={(e) => {
                e.stopPropagation();
                const ids = [id];
                // console.log(id);
                // console.log(state);
                // console.log(ids);
                // console.log(selectedIndexes);
                const finalIds = _.reduce(selectedIndexes, (result, indexValue, key) => {
                  if (key !== initialValue && indexValue) {
                    result.push(key);
                  }
                  return result;
                }, ids);

                selectRow(finalIds);
                setSelectedIndexes({});
              }}
              checked={initialValue?.selected || false}
            />
            <div className="margin-left-10">
              <div className="row">
                {initialValue?.fullName}
              </div>
            </div>
          </div>
        </div>
        <div className="col col-6 col-lg-4">
          <div className="d-flex align-items-center h-100">
            {initialValue?.id === 'teamManager' && (
              <Isvg src={ManagerIcon} className="d-inline-block float-left icon-small icon-primary margin-right-5" />
            )}
            {initialValue?.teams?.name}
          </div>
        </div>
        <div className={classnames('col col-lg-4', { 'd-none': !initialValue?.selected })}>
          <div className="padding-left-checkbox w-100 d-flex negative-margins-6">
            <div className="margin-right-5">
              <InputGroupBlock
                key={`${id}-amount-input`}
                keyId={`${id}-amount-input`}
                onChange={(values) => onChange(values)}
                name="amount"
                inputGroupClassName={classnames('no-input-group', { 'd-none': !initialValue?.selected })}
                className={classnames({
                }, 'no-margin-bottom height-thin')}
                value={initialValue?.amount}
                disabled={splitType === 'total'}
                placeholder=""
                aria-label="Amount"
                type="currency"
              />
            </div>
            <div className="margin-left-5">
              <InputGroupBlock
                key={`${id}-quantity-input`}
                keyId={`${id}-quantity-input`}
                onChange={(e) => onQuantityChange(e)}
                name="quantity"
                icon={PersonIcon}
                inputGroupClassName={classnames('no-input-group icon-small', { 'd-none': splitType !== 'total' || !initialValue?.selected })}
                className={classnames({
                }, 'no-margin-bottom height-thin')}
                value={initialValue?.quantity?.toString()}
                placeholder=""
                min={1}
                max={5}
                aria-label="Quantity"
                type="number"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const TeamMembersTableSelectableAmounts: FC<IProps> = (props: IProps = {
  manual: true,
  actions: undefined,
  teamMembersById: undefined,
  teamMemberIds: undefined,
  initialFilterConfig: undefined,
  persistentFilterConfig: undefined,
  isLoading: false,
  pagination: undefined,
  updateSelectedRows: undefined,
  toggleTeamMemberCreateModal: undefined,
  appReady: false,
  filterable: false,
  selectedAllRows: false,
  selectRow: undefined,
  selectAllRows: undefined,
  removeRow: undefined,
  removeAllRows: undefined,
  selectedRows: undefined,
  selectedRowIds: [],
  handleAmountChange: undefined,
  headerTitle: undefined,
}) => {
  const [selectionBox, setSelectionBox] = useState<Box>();
  const [selectedIndexes, setSelectedIndexes] = useState<{ [key: string]: boolean }>({});
  const selectableItems = useRef<{ [key: string]: Box }>({});
  const selectionId = 'team-members-selectable-rows';

  useEffect(() => {
    selectableItems.current = {};
    const elementsContainer = document.getElementById(selectionId);
    if (elementsContainer) {
      Array.from(elementsContainer.childNodes).forEach((item) => {
        // @ts-ignore
        const {
          left, top, width, height,
        } = item.getBoundingClientRect();

        selectableItems.current[_.replace(item.id, '-row', '')] = {
          left,
          top,
          width,
          height,
        };
      });
    }
  });

  const handleSelectionChange = useCallback(
    (box: Box) => {
      setSelectionBox(box);
      const indexesToSelect: { [key: string]: boolean } = {};
      _.forEach(selectableItems.current, (value, key) => {
        if (boxesIntersect({ ...box, top: box.top + window.scrollY }, value)) {
          indexesToSelect[key] = true;
        } else {
          indexesToSelect[key] = false;
        }
      });

      setSelectedIndexes(indexesToSelect);
    },
    [selectableItems],
  );

  useEffect(() => {
    setSelectedIndexes({});
  }, [JSON.stringify(props.pagination)]);

  useEffect(() => {
    setSelectedIndexes({});
  }, [props.rows]);

  const filterOptions = [
    { label: 'Name', accessor: 'fullName', type: 'text' },
    { label: 'Team', accessor: 'teamName', type: 'text' },
    { label: 'Email', accessor: 'email', type: 'text' },
    { label: 'Mobile', accessor: 'mobile', type: 'text' },
  ];

  const fetchDataFromApi = ({
    sort, filter, pageNumber, pageSize,
  }): void => {
    const payload = {
      page: {
        size: pageSize,
        number: pageNumber,
      },
      sort,
      filter,
    };
    props.actions.getAllTeamMembers(payload);
  };

  const data = useMemo(() => {
    // console.log(new Date().toISOString());
    if (_.isEmpty(props.teamMembersById) || props.teamMemberIds === undefined) {
      return [];
    }
    const rows = [];
    if (props.rows.teamManager !== undefined) {
      const userSummary = {
        id: 'teamManager',
        fullName: props.rows.teamManager?.name,
        teams: {
          name: 'Team Manager',
        },
        dragSelected: selectedIndexes.teamManager,
        selected: props.rows.teamManager?.selected,
        amount: props.rows.teamManager?.amount,
        className: 'highlighted',
        quantity: props.rows.teamManager?.quantity,
        splitType: props.splitType,
      };
      rows.push(userSummary);
    }
    rows.push(..._.reduce(
      props.teamMemberIds,
      (obj, id) => {
        if (!_.isEmpty(props.teamMembersById[id])) {
          const tm = getTeamMemberSummary(props.teamMembersById[id], selectedIndexes[id], props.rows, props.splitType);
          obj.push(tm);
        }
        return obj;
      },
      [],
    ));
    return rows;
  }, [props.teamMembersById, JSON.stringify(props.teamMemberIds), JSON.stringify(props.rows), selectedIndexes, props.splitType]);

  const rowData = useMemo(() => {
    const accumulator = [];
    if (props.rows.teamManager !== undefined) {
      accumulator.push(getTeamMemberRowDataNew(props.rows.teamManager, props.splitType));
    }
    const rows = _.reduce(_.sortBy(props.rows, ['teamName', 'fullName']), (obj, row) => {
    // const rows = _.reduce(props.rows, (obj, row) => {
      if (row.id !== 'teamManager' && _.includes(props.teamMemberIds, row.id)) {
        const tm = getTeamMemberRowDataNew(row, props.splitType);
        obj.push(tm);
      }
      return obj;
    }, accumulator);
    return rows;
  }, [JSON.stringify(props.rows), props.teamMemberIds, JSON.stringify(props.teamMembersById), props.splitType]);

  const columns = useMemo(() => [
    {
      Header: renderCheckboxHeader,
      // Header: (value) => renderCheckboxHeader(value),
      accessor: (row) => (row),
      id: 'select',
      className: 'col more-padding',
      headerClassName: 'col more-padding',
      Cell: renderTeamMemberRow,
      // Cell: (value) => renderTeamMemberRow(value),
      selectRow: (finalIds) => props.selectRow(finalIds),
      disableSortBy: true,
      setSelectedIndexes,
      selectedIndexes,
      selectedAllRows: props.selectedAllRows,
      selectAllRows: props.selectAllRows,
      handleChange: (id, values) => props.handleAmountChange(id, values),
      handleQuantityChange: (id, value) => props.handleQuantityChange(id, value),
    },
  ], [selectedIndexes]);

  return (
    <div id="team-members-selectable">
      <MouseSelection onSelectionChange={handleSelectionChange} />
      <Table
        data={rowData}
        // rowState={rowState}
        columns={columns}
        expanded={_.map(data, (row) => ({ id: row.id, expanded: true }))}
        isLoading={props.isLoading}
        headerTitle={props.headerTitle}
        objectTitle="team members"
        filterTitle="Team Members Data"
        filterable
        tableState={props.tableState}
        handleClick={undefined}
        saveFilters={props.saveFilters}
        dragSelected={selectedIndexes}
        manual={props.manual}
        defaultPageSize={1000}
        fetchDataFromApi={fetchDataFromApi}
        filterOptions={filterOptions}
        filterConfig={props.initialFilterConfig}
        persistentFilterConfig={props.persistentFilterConfig}
        pagination={props.pagination}
        useExpanded
        showPagination
        rowSelectableContainerId={selectionId}
      />
    </div>
  );
};
export default TeamMembersTableSelectableAmounts;
